import { CART_UPDATE_RICH_RELEVANCE } from '../Cart.types';
import EApiMiddlewareMethod from 'config/redux/middlewares/api.middleware.enum';
import {
  UPDATE_RICH_RELEVANCE_CART,
  UPDATE_RICH_RELEVANCE_OC,
} from 'pages/Cart/constants/apis.constant';
import { getHashedEmailFromCookie } from 'utils/cookies.util';

export const triggerRichRelevanceUpdate = (params: { [key: string]: any }) => {
  const { rrURI, isFromCart = true, ...restParams } = params;
  return {
    type: CART_UPDATE_RICH_RELEVANCE,
    payload: {
      method: EApiMiddlewareMethod.GET,
      url: isFromCart ? UPDATE_RICH_RELEVANCE_CART : UPDATE_RICH_RELEVANCE_OC,
      params: restParams,
      apiVersion: 1,
      headers: {
        userId: getHashedEmailFromCookie(),
      },
    },
  };
};
